export default __webpack_public_path__ + "static/media/1.38c19794.jpg";